import styled from "styled-components/macro";
import Button from "react-bootstrap/Button";

const RightFloatButton = styled(Button)`
  margin-left: auto;
`;

export default RightFloatButton;
